// extracted by mini-css-extract-plugin
export default {"avatar":"OM5Ob57k_BAiB8sCAKOD","avatar-participant":"dqMlOm76t83IZETr2cjV"};